export const debounceWithAnimationFrame = <T extends Function>(cb: T) => {
    let animationFrame = 0;
    let callable = (...args: unknown[]) => {
        cancelAnimationFrame(animationFrame);
        animationFrame = requestAnimationFrame(() => cb(...args));
    };
    return (callable as any) as T;
};
